import { render, staticRenderFns } from "./ReleasesArtistsEditPanel.vue?vue&type=template&id=3d9970b4"
import script from "./ReleasesArtistsEditPanel.vue?vue&type=script&lang=js"
export * from "./ReleasesArtistsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./ReleasesArtistsEditPanel.vue?vue&type=style&index=0&id=3d9970b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports